import {dynamicWrapper, createRoute} from '@/utils/core';

const routesConfig = app => ({
    path: '/homepage/roomOfGroup',
    title: '房源分组',
    component: dynamicWrapper(app, [import('./model/index')], () => import('./components/index'))
});

export default app => createRoute(app, routesConfig);
